import { OFFER, PRODUCT } from 'config/api-routes';
import { GET, PATCH, POST } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

export default class OfferService {
  async createOffer(data, opts = {}) {
    const response = await POST(OFFER.CREATE.POST(), data, opts);

    return formatResponse(response);
  }

  async createCounterOffer(data, opts = {}) {
    const response = await POST(OFFER.COUNTER.POST(), data, opts);

    return formatResponse(response);
  }

  async createSellerOffer(data: { productId: number; buyerId: number; offeredPrice: number }, opts = {}) {
    const response = await POST(OFFER.SELLER.POST(), data, opts);

    return formatResponse(response);
  }

  async respondToOffer(data, opts = {}) {
    const response = await PATCH(OFFER.UPDATE.PATCH(), data, opts);

    return formatResponse(response);
  }

  async cancelAcceptedOffers(productId: number, opts = {}): Promise<{ cancelledCount: number }> {
    const response = await POST(PRODUCT.ACCEPTED_OFFERS.CANCEL.POST(productId), {}, opts);

    return formatResponse(response);
  }

  async getOffer(offerId: number, opts = {}) {
    const response = await GET(OFFER.ONE.GET(offerId), opts);

    return formatResponse(response);
  }
}
